// validation user infomation with yup

import yup from '@/utils/yup-global'

// ví dụ 1 cái nhe
export const userValidation = yup.object().shape({
  name: yup.string().required('Name is required'),
  email: yup.string().email('Invalid email').required('Email is required'),
})
export const pwSchema = yup.object().shape({
  oldPw: yup.string().password().required('Mật khẩu cũ không được để trống'),
  pw: yup.string().password().required('Mật khẩu không được để trống'),
  pw1: yup
    .string()
    .password()
    .oneOf([yup.ref('pw')], 'Mật khẩu không khớp')
    .required('Xác nhận mật khẩu không được để trống'),
})

export const userSchema = yup.object().shape({
  firstname: yup.string().required('First name is required'),
  lastname: yup.string().required('Họ và tên không được để trống'),
  email: yup.string().email('Invalid email').required('Email không được để trống'),
  phone_number: yup.string().required('Số điện thoại không được để trống').phoneNumber('Invalid number'),
  date_of_birth: yup.string().required('Ngày sinh không được để trống'),
  city_id: yup.string().notRequired(),
  district_id: yup.string().notRequired(),
  ward_id: yup.string().notRequired(),
  account_holder: yup.string().notRequired(),
  account_number: yup.string().notRequired(),
  account_bank: yup.string().notRequired(),
})

export const loginSchema = yup.object().shape({
  email: yup
    .string()
    .required('Vui lòng nhập email hoặc số điện thoại')
    .test('email-or-phone', 'Email hoặc số điện thoại không hợp lệ', (value) => {
      if (!value) return false
      // Kiểm tra format email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      // Kiểm tra format số điện thoại Việt Nam
      const phoneRegex = /^(0|\+84)[3-9]\d{8,9}$/

      return emailRegex.test(value) || phoneRegex.test(value)
    }),
  password: yup.string().required('Mật khẩu không được để trống'),
})

export const registerSchema = yup.object().shape({
  // firstname: yup.string().required(),
  lastname: yup.string().required('Họ và tên không được để trống'),
  password: yup.string().password().required('Mật khẩu không được để trống'),
  email: yup.string().email('Email không hợp lệ').required('E-mail hoặc số điện thoại không được để trống'),
  mobile_phone: yup
    .string()
    .phoneNumber('Số điện thoại không hợp lệ')
    .required('Số điện thoại không được để trống'),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password')], 'Mật khẩu không khớp')
    .required('Xác nhận mật khẩu không được để trống'),
})

// Dựa trên type IAddressCustomer trong @file_context_0
export const addressSchema = yup.object().shape({
  firstname: yup.string().required('Tên không được để trống'),
  lastname: yup.string().required('Họ không được để trống'),
  telephone: yup
    .string()
    .phoneNumber('Số điện thoại không hợp lệ')
    .required('Số điện thoại không được để trống'),
  city: yup.string().required('Tỉnh/Thành phố không được để trống'),
  city_id: yup.string().required('Mã tỉnh/thành phố không được để trống'),
  country_code: yup.string().default('VN').required('Mã quốc gia không được để trống'),
  district_id: yup.string().required('Quận/Huyện không được để trống'),
  ward_id: yup.string().required('Phường/Xã không được để trống'),
  street: yup.string().required('Địa chỉ chi tiết không được để trống'),
  custom_attributes: yup.array().of(
    yup.object().shape({
      value: yup.string().required(),
      attribute_code: yup.string().required(),
    })
  ),
  default_billing: yup.string(),
  default_shipping: yup.string(),
  // Các trường dưới đây có thể tùy chọn nếu form có thêm
  id: yup.string(),
  middlename: yup.string(),
  region_id: yup.string(),
  suffix: yup.string(),
  vat_id: yup.string(),
  // "setDefault" & "addressType" là các field thêm cho UX (không có trong type chính thống, có thể optional)
  setDefault: yup.array(),
  addressType: yup.string(),
})

export const forgotPwSchema = yup.object().shape({
  email: yup.string().email('Email không hợp lệ').required('Email không được để trống'),
})

export const resetPwSchema = yup.object().shape({
  password: yup.string().password('Mật khẩu không hợp lệ').required('Mật khẩu không được để trống'),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password')], 'Mật khẩu không khớp')
    .required('Xác nhận mật khẩu không được để trống'),
})

export const reviewFormSchema = yup.object().shape({
  nickname: yup.string().required(),
  summary: yup.string().required(),
})

// Schema cho đăng nhập bằng OTP
export const otpRequestSchema = yup.object().shape({
  phone: yup.string().phoneNumber('Số điện thoại không hợp lệ').required('Số điện thoại không được để trống'),
})

export const otpVerifySchema = yup.object().shape({
  phone: yup.string().phoneNumber('Số điện thoại không hợp lệ').required('Số điện thoại không được để trống'),
  otp: yup
    .string()
    .matches(/^\d{6}$/, 'Mã OTP phải là 6 chữ số')
    .required('Mã OTP không được để trống'),
})

// Schema cho cập nhật mật khẩu lần đầu
export const setInitialPasswordSchema = yup.object().shape({
  newPassword: yup.string().password('Mật khẩu không hợp lệ').required('Mật khẩu không được để trống'),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('newPassword')], 'Mật khẩu không khớp')
    .required('Xác nhận mật khẩu không được để trống'),
})

// Schema cho identifier (email hoặc số điện thoại)
export const identifierSchema = yup.object().shape({
  identifier: yup
    .string()
    .required('Vui lòng nhập email hoặc số điện thoại')
    .test('email-or-phone', 'Email hoặc số điện thoại không hợp lệ', (value) => {
      if (!value) return false
      // Kiểm tra format email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      // Kiểm tra format số điện thoại Việt Nam
      const phoneRegex = /^(0|\+84)[3-9]\d{8,9}$/

      return emailRegex.test(value) || phoneRegex.test(value)
    }),
})

// Schema cho OTP verification
export const otpVerificationSchema = yup.object().shape({
  otp: yup
    .string()
    .required('Vui lòng nhập mã OTP')
    .length(6, 'Mã OTP phải có 6 chữ số')
    .matches(/^\d{6}$/, 'Mã OTP chỉ chứa số'),
})

// Schema cho form địa chỉ giao hàng
export const deliveryAddressSchema = yup.object().shape({
  // Các field bắt buộc
  lastname: yup.string().required('Họ và tên không được để trống'),
  telephone: yup
    .string()
    .phoneNumber('Số điện thoại không hợp lệ')
    .required('Số điện thoại không được để trống'),
  city_id: yup.string().required('Vui lòng chọn Tỉnh/Thành phố'),
  district_id: yup.string().required('Vui lòng chọn Quận/Huyện'),
  ward_id: yup.string().required('Vui lòng chọn Phường/Xã'),
  address: yup.string().required('Địa chỉ nhà không được để trống'),

  // Các field không bắt buộc
  tag: yup.string().notRequired(),
  firstname: yup.string().notRequired(),
  middlename: yup.string().notRequired(),
  suffix: yup.string().notRequired(),
  city: yup.string().notRequired(),
  region_id: yup.string().notRequired(),
  country_code: yup.string().notRequired(),
  default_billing: yup.string().notRequired(),
  default_shipping: yup.string().notRequired(),
  street: yup.string().notRequired(),
  vat_id: yup.string().notRequired(),
  id: yup.string().notRequired(),
  custom_attributes: yup.array().notRequired(),
  setDefault: yup.boolean().notRequired(),
})
